import React, {useRef} from 'react'
import { ContactContainer, FormWrap, Form, FormH1, FormLabel, FormInput, FormInputTextArea, FormButton } from './ContactElements'
import Swal from 'sweetalert2';
import emailjs from "@emailjs/browser";

const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    
    emailjs
      .sendForm(
        "service_gu4m9pa",
        "template_g9pj84c",
        form.current,
        "n6IXVg7w-gLlOrF_8"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
          Swal.fire({
            icon: 'success',
            title: 'Message Sent Successfully'
          })
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            icon: 'error',
            title: 'Ooops, something went wrong',
            text: error.text,
          })
        }
      );
      e.target.reset()
  };

  return (
    <>
      <ContactContainer> 
        <FormWrap id='contact'>
              <Form ref={form} onSubmit={sendEmail}>
                  <FormH1 className='font-family-Mont'>contact me</FormH1>
                  <FormLabel htmlFor='for' className='font-family-Mont'>name</FormLabel>
                  <FormInput type="text" required name="user_name"/>
                  <FormLabel htmlFor='for' className='font-family-Mont'>email</FormLabel>
                  <FormInput type="email" required  name="user_email"/>
                  <FormLabel htmlFor='for' className='font-family-Mont'>message</FormLabel>
                  <FormInputTextArea type="textarea" required name="message"/>
                  <FormButton type='submit' value="Send" className='font-family-Mont'>submit</FormButton>
              </Form>
          </FormWrap>
      </ContactContainer>
    </>
  )
}

export default Contact
